module.exports = __webpack_public_path__ + "static/euroautokar-2d36eada9afaaaeeb5b6162ed1140bf3.png";